import { GetStaticPaths } from 'next';
import { CHANNELS, SEGMENTS } from '@sparknz/journeys-common';

import { DeviceGalleryQuery$data } from '__generated__/DeviceGalleryQuery.graphql';
import { HeaderContentQuery$data } from '__generated__/HeaderContentQuery.graphql';
import DeviceGalleryJourney, {
  formatDeviceGalleryMeta,
} from 'journey/deviceGallery';
import { withGetStaticProps } from 'shared/api';
import { MetaTags } from 'shared/components';
import { DEVICE_GALLERY_JOURNEY, MOBILE_BUY_JOURNEY } from 'shared/constants';
import generateJourneyName from 'shared/utils/generateJourneyName.utils';

interface DeviceGalleryPageProps {
  deviceGallery: DeviceGalleryQuery$data['deviceGallery'];
  categoryId: string;
  journeyName: string;
  headerContent?: HeaderContentQuery$data;
}

const journeyName = generateJourneyName({
  channel: CHANNELS.BUSINESS_SHOP,
  journey: MOBILE_BUY_JOURNEY,
  pageName: DEVICE_GALLERY_JOURNEY,
});

export default function DeviceGalleryPage({
  deviceGallery,
  headerContent,
  categoryId,
}: DeviceGalleryPageProps) {
  const metaData = formatDeviceGalleryMeta({
    deviceGallery,
    categoryId,
    segment: SEGMENTS.BUSINESS,
  });

  return (
    <>
      <MetaTags {...metaData} />
      <DeviceGalleryJourney
        deviceGallery={deviceGallery}
        headerContent={headerContent}
      />
    </>
  );
}

export const getStaticPaths: GetStaticPaths = () => {
  return { paths: [], fallback: 'blocking' };
};

export const getStaticProps = withGetStaticProps<DeviceGalleryPageProps>(
  async ({ params }, services) => {
    const categoryId = params.categoryId.toString();

    const { deviceGallery } = await services.fetchDeviceGallery(
      categoryId,
      CHANNELS.BUSINESS_SHOP,
      'DEFAULT',
    );

    return { props: { categoryId, deviceGallery, journeyName } };
  },
  journeyName,
);
